import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { errorHandler } from './services/errorHandler'
import { logger } from './services/logger'

// Initialize global error handler
errorHandler.initialize({
  showNotifications: !import.meta.env.PROD,
  onError: (error, context) => {
    // Custom error handling logic can be added here
    // For example, sending to analytics or error tracking service
    if (import.meta.env.PROD) {
      // In production, could send to Sentry, LogRocket, etc.
      logger.debug('Error context for analytics', {
        category: context.category,
        severity: context.severity,
      })
    }
  },
})

const rootEl = document.getElementById('root')
if (rootEl === null) {
  // Fail fast but safely if root element is missing
  logger.error('Root element #root not found', new Error('Root element missing'))
} else {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
}
